import { render, staticRenderFns } from "./products-config.vue?vue&type=template&id=5c018e87"
import script from "./products-config.vue?vue&type=script&lang=js"
export * from "./products-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports